// Must be first: installs the SDK's global error handlers before any other
// module is evaluated. No-op unless VITE_GLITCHTIP_DSN is set.
import './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  QueryClient,
  QueryClientProvider,
  QueryCache,
  MutationCache,
} from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { reportClientError } from './lib/glitchtip';
import './index.css';

// Query and mutation failures are handled locally by each screen, so they never
// bubble to a boundary or to `window.onerror`. Reporting from the cache-level
// hooks is what makes a failed fetch visible in GlitchTip at all.
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      reportClientError(error, { source: 'react-query', query_key: query.queryHash });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      reportClientError(error, {
        source: 'react-mutation',
        mutation_key: mutation.options.mutationKey?.join('/'),
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5000,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
